import { useEffect } from "react";
import $ from "jquery";
import "select2/dist/css/select2.min.css";
import "select2";

const SteppersBehaviour = () => {

  useEffect(() => {

    const filler = document.getElementById('dynamic-filler');
    const rightCol = document.querySelector('.right');

    // ================================
    // ✅ SELECT2 INIT
    // ================================
    $(".select2-dropdown").each(function () {

      const $this = $(this);

      $this.select2({
        placeholder: $this.data('placeholder'),
        allowClear: true,
        width: '100%'
      });

      const title = $this.attr("title");
      if (title) {
        $this.next(".select2-container")
          .find(".select2-selection")
          .attr("title", title);
      }

      $this.on('select2:open', function () {
        $this.closest('.custom-floating').addClass('focused');
      });

      $this.on('select2:close', function () {
        $this.closest('.custom-floating').removeClass('focused');
      });

      $this.on('change', function () {
        const wrapper = $this.closest('.custom-floating');

        if ($this.val()) {
          wrapper.addClass('has-value');
          wrapper.removeClass('error');
        } else {
          wrapper.removeClass('has-value');
        }

        rightCol?.dispatchEvent(new Event('input', { bubbles: true }));
      });

      if ($this.val()) {
        $this.closest('.custom-floating').addClass('has-value');
      }
    });

    // ================================
    // ✅ GOOGLE MAPS PLACE AUTOCOMPLETE
    // ================================
    function loadGoogleMaps(callback) {
      if (window.google && window.google.maps) {
        callback();
        return;
      }

      const script = document.createElement("script");
      script.src = "https://maps.googleapis.com/maps/api/js?key=YOUR_KEY&libraries=places";
      script.async = true;
      script.defer = true;
      script.onload = callback;
      document.body.appendChild(script);
    }

    loadGoogleMaps(() => {
      const propertyInput = document.getElementById("propertyInput");
      if (propertyInput) {
        const autocomplete = new window.google.maps.places.Autocomplete(propertyInput, {
          types: ["address"],
          componentRestrictions: { country: "us" }
        });

        autocomplete.addListener("place_changed", () => {
          const place = autocomplete.getPlace();
          if (!place.geometry) return;
          console.log("Selected address:", place.formatted_address);
        });
      }
    });
    // ================================
    // ✅ PROGRESS BAR
    // ================================
    rightCol?.addEventListener('input', () => {

      const activeStep = document.querySelector('.form-step:not(.d-none)');
      if (!activeStep) return;

      const stepId = activeStep.id;
      const inputs = activeStep.querySelectorAll('.count-progress');
      const totalInputs = inputs.length;

      let filledCount = 0;

      inputs.forEach(input => {
        if (input.value && input.value.trim() !== "") {
          filledCount++;
        }
      });

      let progress = 0;

      if (stepId === 'step-1') {
        progress = 25 + (filledCount / totalInputs * 25);
      } else if (stepId === 'step-2') {
        progress = 50 + (filledCount / totalInputs * 50);
      }

      if (filler) filler.style.width = progress + "%";
    });


    function togglePriceFields() {
    // Get selected text and normalize
    const selectedText = $("#transactionInput option:selected").text().trim().toLowerCase();
    const purchaseWrapper = $("#purchasePriceWrapper");
    const currentWrapper = $("#currentPriceWrapper");

    if (selectedText === "purchase") {
        purchaseWrapper.show();
        $("#purchasePriceInput").prop("required", true);
        currentWrapper.hide();
        $("#currentPriceInput").prop("required", false);
    } else if (selectedText === "refinance") {
        purchaseWrapper.hide();
        $("#purchasePriceInput").prop("required", false);
        currentWrapper.show();
        $("#currentPriceInput").prop("required", true);
    } else {
        // Neither Purchase nor Refinance selected
        purchaseWrapper.hide();
        $("#purchasePriceInput").prop("required", false);
        currentWrapper.hide();
        $("#currentPriceInput").prop("required", false);
    }
}

// Run on page load
togglePriceFields();

// Run whenever Select2 changes
$("#transactionInput").on("change", togglePriceFields);
    // ================================
    // ✅ FORM VALIDATION
    // ================================
    const step1Form = document.getElementById("financing-form");

step1Form?.addEventListener("submit", function(e) {
    e.preventDefault();

    const fields = step1Form.querySelectorAll(".required-input, select[required]");
    let isValid = true;

    fields.forEach(f => {
        const wrapper = f.closest(".custom-floating");
        if (!f.value || f.value.trim() === "") {
            wrapper.classList.add("error");
            isValid = false;
        } else {
            wrapper.classList.remove("error");
        }
    });

    if (!isValid) return;

    // AJAX submit
    const formData = new FormData(step1Form);
    fetch("", {
        method: "POST",
        headers: {
            "X-CSRFToken": formData.get("csrfmiddlewaretoken")
        },
        body: formData
    })
    .then(res => res.json())
    .then(data => {
        if (data.success && data.next_step === 2) {
            nextStep(2); // move to Step 2
        }
    });
});

  }, []);

  return null;
};

// ✅ IMPORTANT FIX
export default SteppersBehaviour;


// ================================
// ✅ STEP FUNCTION (outside component)
// ================================
function nextStep(stepNumber) {

  document.querySelectorAll('.form-step').forEach(step => {
    step.classList.add('d-none');
  });

  document.getElementById('step-' + stepNumber)?.classList.remove('d-none');

  const filler = document.getElementById('dynamic-filler');

  if (filler) {
    filler.style.width = stepNumber === 2 ? "50%" : "25%";
  }
}
